import { List } from 'antd';
import styled from 'styled-components';

export const StyledItem = styled.div`
  cursor: pointer;
  font-size: 16px;
  line-height: 17px;
  color: #4a4a4a;
`;


export const StyledListItem = styled(List.Item)`
  .ant-list-item-meta .ant-list-item-meta-description {
    font-size: 12px !important;
  }

  .session-delete-btn {
    display: none !important;
  }

  &:hover {
    .session-delete-btn {
      display: block !important;
    }
  }
`;
